<template>
  <div class="refund-record-item">
    <div class="rufund-info">
      <p class="rufund-id">{{ $t('orderRefund.RufundID') }}: {{ defaultTips(data.refundId) }}</p>
      <p class="rufund-time">{{ $t('orderRefund.RufundTime') }}: {{ defaultTips(formatTimeStamp(data.refundDate)) }}</p>
      <p>{{ $t('orderRefund.RefundAmount') }}: {{ `$${defaultTips(data.refundAmount)}` }}</p>
    </div>

    <div v-for="(item, index) in data.refunds" :key="index" class="steps">
      <div class="step">
        <div class="step-head">
          <div class="step-icon is-active" />
          <div v-if="index !== data.refunds.length - 1" class="step-line" />
        </div>
        <div class="step-main">
          <p v-if="item.status === 2" :class="['title', 'warning']">{{ `${ordersStatus(item.status)} ${defaultTips(item.refundFailReason)}` }}</p>
          <p v-else class="title">{{ ordersStatus(item.status) }}</p>
          <p class="subheading">{{ `${defaultTips(formatTimeStamp(item.createDate))}` }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTimeStamp } from '@/util/moment'

export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      formatTimeStamp
    }
  },
  computed: {
    ordersStatus() {
      return (value) => {
        value = Number.parseInt(value)
        switch (value) {
          case 0:
            return `${this.$t('orderRefund.RefundApplication')}` // 申请退款
          case 1:
            return `${this.$t('orderRefund.RefundSucceeded')}` // 退款成功
          case 2:
            return `${this.$t('orderRefund.RefundFailed')}` // 退款失败
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.refund-record-item {
  margin-bottom: 25px;
  border-bottom: 1px solid #cdd4dd;
  &:last-child {
    margin-bottom: 0;
    border-bottom: 0;
  }
}

.rufund-info {
  color: #10141d;
  .rufund-time {
    margin: 8px 0;
  }
}

.steps {
  margin-top: 20px;
  .step {
    display: flex;
    position: relative;
    height: 68px;
    .step-head {
      height: 100%;
      .step-icon {
        position: absolute;
        top: 2px;
        left: 0;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 1px solid #cdd4dd;
        background-color: #f5f7f7;
        z-index: 1;
        &.is-active {
          border: 1px solid #99c41c;
          background-color: #99c41c;
        }
      }
      .step-line {
        position: absolute;
        top: 2px;
        left: 5px;
        width: 2px;
        height: 100%;
        background-color: #cdd4dd;
      }
    }
    .step-main {
      flex: 1;
      margin-left: 22px;
      .title {
        color: #110808;
        margin-bottom: 5px;
        &.warning {
          color: #eb5757;
        }
      }
      .subheading {
        color: #747a87;
      }
    }
  }
}
</style>
